module.exports = __webpack_public_path__ + "img/om.4afe5337.svg";